import { render, staticRenderFns } from "./ShowUrlImage.vue?vue&type=template&id=25ee9fa8"
import script from "./ShowUrlImage.vue?vue&type=script&lang=js"
export * from "./ShowUrlImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports